/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-01-13 15:45:17
 * @modify date 2022-01-13 15:45:17
 */

import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { 
  withEnvironment,
  withGeneralError,
  withSetValue,
  withReset,
  withRootStore
} from "models/extensions"

import { cupperProps } from './cupper-props'
import { withCuppersViews } from './cupper-view'
import { withCupperActions } from './cupper-action'

/**
 * Model description here for TypeScript hints.
 */
export const CupperStoreModel = types
  .model("CupperStore")
  .props(cupperProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withGeneralError)
  .extend(withSetValue)
  .extend(withReset)
  .extend(withCuppersViews)
  .extend(withCupperActions)

type CupperStoreType = Instance<typeof CupperStoreModel>
export interface CupperStore extends CupperStoreType {}
type CupperStoreSnapshotType = SnapshotOut<typeof CupperStoreModel>
export interface CupperStoreSnapshot extends CupperStoreSnapshotType {}
